import React, { useEffect } from 'react';
import PostPreview from './PostPreview';
import { truncate, getFirstImageFromPost, removeHTMLTags } from '../../utils/helpers';
import orderBy from 'lodash/orderBy';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var PostPreviewList = function PostPreviewList(_ref) {
  var provider = _ref.provider,
      providerService = _ref.providerService,
      _ref$posts = _ref.posts,
      posts = _ref$posts === void 0 ? [] : _ref$posts,
      getPosts = _ref.getPosts;
  useEffect(function () {
    if (!providerService) {
      return;
    }

    getPosts(providerService.id);
  }, [providerService]);
  var publishedPosts = posts.filter(function (p) {
    return p.published;
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (publishedPosts === null || publishedPosts === void 0 ? void 0 : publishedPosts.length) > 0 ? /*#__PURE__*/_jsx("div", {
      className: "relative w-full mx-auto mb-14 px-2 sm:px-4 xl:px-8",
      "data-cy": "PostPreviewList",
      children: /*#__PURE__*/_jsx("div", {
        className: "w-full xl:w-11/12 mx-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: 'grid grid-cols-1 md:grid-cols-3 gap-x-4',
          children: orderBy(publishedPosts, ['publishedAt'], ['desc']).map(function (post) {
            var title = post.title,
                body = post.body,
                publishedAt = post.publishedAt;
            var postPreview = truncate(removeHTMLTags(body), 127);
            return post.published && /*#__PURE__*/_jsx(PostPreview, {
              previewText: postPreview,
              title: title,
              postImageSrc: getFirstImageFromPost(body),
              date: publishedAt,
              postLocation: "/".concat(provider.slug, "/posts/").concat(post.slug),
              isPaid: post.grantorType !== 'free'
            }, post.id);
          })
        })
      })
    }) : /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center h-96",
      children: /*#__PURE__*/_jsx("div", {
        className: "mt-8",
        children: "No published posts yet"
      })
    })
  });
};